export const isOperationRole = () => {
    return !["CUST", "PARTNER"].includes(sessionStorage.getItem("userRole"));
}

export const isPartnerRole = () => {
    return "PARTNER" === sessionStorage.getItem("userRole");
}

export const isAccountCheckerRole = () => {
    return "ACCCH" === sessionStorage.getItem("userRole");
}

export const isAccountMakerRole = () => {
    return "ACCMK" === sessionStorage.getItem("userRole");
}